import React from "react";
import "./Referralearn.css";

const HowItWorks = ({ summaryQuery }) => {
  const howItWorksSteps = [
    { id: 1, description: summaryQuery.data?.rewards?.referrer?.description || "", icon: "bi-envelope", iconClass: "orange" },
    { id: 2, description: "Invite your friend to register using your referral code", icon: "bi-person-plus-fill", iconClass: "green" },
    { id: 3, description: "Both of you receive reward coins in your wallet", icon: "fa-solid fa-wallet", iconClass: "purple" },
  ];
  return (
    <div className="how-it-works">
      {howItWorksSteps.map((step) => (
        <div className="how-it-works__card" key={step.id}>
          <div className={`how-it-works__icon ${step.iconClass}`}>
             <i className={step.icon}></i>
          </div>

          <div className="how-it-works__content">
            <h4>Step {step.id}</h4>
            {step.id === 1 && summaryQuery.isPending ? <span className="dashboard-skeleton referral-shimmer-line" aria-label="Loading step description" /> : step.id === 1 && summaryQuery.isError ? <button type="button" onClick={() => summaryQuery.refetch()}>Retry loading reward details</button> : <p>{step.description}</p>}
          </div>
        </div>
      ))}
    </div>
  );
};

export default HowItWorks;
